import React from 'react';
import { SvgProps } from '../Login';
import './Buildings.module.scss';

export default function Tent(props: SvgProps) {
    return (
        <>
            <svg
                styleName={`top tent ${props.selectedColor}`}
                id="Layer_2"
                data-name="Layer 2"
                xmlns="http://www.w3.org/2000/svg"
                width="226"
                height="133.94"
                viewBox="0 0 226 133.94"
            >
                <defs>
                    <style>{`.cls-1,.cls-8{opacity:0.1;}.cls-2{isolation:isolate;}.cls-3{fill:#28e57d;}.cls-4{fill:#e2c49a;}.cls-5{fill:#8e674a;}.cls-6{fill:lime;}.cls-11,.cls-7{fill:#fff;}.cls-14,.cls-7{opacity:0.2;}.cls-10,.cls-9{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.47px;}.cls-9{stroke:#3a3a3a;}.cls-10{stroke:#fff;}.cls-12{fill:#c7302d;}.cls-13{fill:#754c24;}.cls-15{fill:#3db371;}`}</style>
                </defs>
                <g className="cls-1">
                    <g className="cls-2">
                        <path d="M147.43,47.57c18.92,15.47,19,40.55.23,56s-49.38,15.47-68.29,0-19-40.54-.23-56S128.51,32.1,147.43,47.57Z" />
                    </g>
                </g>
                <g className="cls-2">
                    <path
                        className="cls-3"
                        d="M134.25,67.83c11.47,7,11.53,18.36.14,25.37s-29.93,7-41.4,0-11.53-18.37-.14-25.37S122.78,60.82,134.25,67.83Z"
                    />
                </g>
                <g className="cls-2">
                    <path
                        className="cls-3"
                        d="M137.65,69.65s13.56,21.6.16,29.84-35.21,8.24-48.7,0S89,69.65,89,69.65Z"
                    />
                </g>
                <g className="cls-2">
                    <path
                        className="cls-4"
                        d="M132.15,67.64c10.3,5.87,10.36,15.39.12,21.25s-26.88,5.87-37.18,0S84.73,73.51,95,67.64,121.85,61.77,132.15,67.64Z"
                    />
                </g>
                <g className="cls-2">
                    <path
                        className="cls-5"
                        d="M132.15,65.6c10.3,3.91,10.36,10.26.12,14.17s-26.88,3.91-37.18,0S84.73,69.51,95,65.6,121.85,61.68,132.15,65.6Z"
                    />
                </g>
                <path
                    styleName="cls-6 medium"
                    d="M144.08,92h0V37.37L113.49,3.17h0L82.91,37.37V92s29.54-2,30.58-34.19h0C114.54,90,144.08,92,144.08,92Z"
                />
                <polygon
                    className="cls-7"
                    points="82.91 37.37 82.91 92.01 113.49 57.82 113.49 3.17 82.91 37.37"
                />
                <path className="cls-8" d="M144.08,92s-29.54-2-30.59-34.19Z" />
                <line
                    className="cls-9"
                    x1="144.08"
                    y1="90.3"
                    x2="148.44"
                    y2="86.93"
                />
                <line
                    className="cls-9"
                    x1="83.69"
                    y1="89.11"
                    x2="80.32"
                    y2="84.75"
                />
                <line
                    className="cls-9"
                    x1="142.89"
                    y1="38.56"
                    x2="145.86"
                    y2="31.82"
                />
                <line
                    className="cls-9"
                    x1="84.52"
                    y1="38.56"
                    x2="82.85"
                    y2="31.82"
                />
                <line
                    className="cls-10"
                    x1="113.49"
                    y1="57.61"
                    x2="113.49"
                    y2="112.11"
                />
                <line
                    className="cls-9"
                    x1="113.52"
                    y1="112.11"
                    x2="117.88"
                    y2="108.73"
                />
                <polygon
                    className="cls-11"
                    points="118.09 33.48 129.3 37.64 124.05 40.31 126.66 44.59 115.66 41.76 118.09 33.48"
                />
                <path
                    className="cls-9"
                    d="M113.62,57.37a79.35,79.35,0,0,1,4.47-23.89"
                />
                <circle className="cls-12" cx="118.09" cy="33.11" r="1.49" />
                <path
                    className="cls-13"
                    d="M187.77,70.47l1.58-16.17-5.77-.56L182,69.9a1.37,1.37,0,0,0,.7,1.39,4.54,4.54,0,0,0,4.11.4A1.36,1.36,0,0,0,187.77,70.47Z"
                />
                <path
                    className="cls-14"
                    d="M188.19,54.19l-1.57,16.17a1.37,1.37,0,0,1-1,1.22,3.89,3.89,0,0,1-1.52.32,4.44,4.44,0,0,0,2.67-.21,1.36,1.36,0,0,0,1-1.22l1.58-16.17Z"
                />
                <path
                    className="cls-15"
                    d="M199.67,55.31l0-.14c0-.58-8.87-45.33-8.87-45.33S173.42,52,173.3,52.63l0,.1h0c-.34,2,.74,4.27,3.32,6.11,4.88,3.49,13.24,4.31,18.67,1.82,2.87-1.31,4.33-3.28,4.37-5.36Z"
                />
                <path
                    className="cls-14"
                    d="M199.64,55.17c0-.58-8.87-45.33-8.87-45.33s6.33,40.9,6.34,41.48l0,.14h0c0,2.08-1.5,4-4.37,5.36-5.43,2.49-13.8,1.67-18.68-1.82-.26-.19-.5-.39-.74-.58a7.58,7.58,0,0,0,3.28,4.43c4.88,3.49,13.24,4.31,18.67,1.82,2.87-1.31,4.33-3.28,4.37-5.36h0Z"
                />
                <path
                    className="cls-13"
                    d="M73,56.43l.65-9.81-3.5-.23-.65,9.8A.83.83,0,0,0,70,57a2.74,2.74,0,0,0,2.49.17A.85.85,0,0,0,73,56.43Z"
                />
                <path
                    className="cls-14"
                    d="M73,46.57l-.65,9.81a.81.81,0,0,1-.55.76,2.44,2.44,0,0,1-.91.22,2.72,2.72,0,0,0,1.61-.17.85.85,0,0,0,.55-.76l.65-9.81Z"
                />
                <path
                    className="cls-15"
                    d="M79.92,47l0-.09c0-.35-6.22-27.25-6.22-27.25S64,45.54,63.92,45.91l0,.07h0c-.17,1.24.53,2.56,2.12,3.63a12.5,12.5,0,0,0,11.33.75c1.71-.85,2.56-2.07,2.54-3.33Z"
                />
                <path
                    className="cls-14"
                    d="M79.9,47c0-.35-6.22-27.25-6.22-27.25s4.6,24.62,4.62,25l0,.08h0c0,1.26-.83,2.48-2.54,3.33a12.5,12.5,0,0,1-11.33-.75A4.22,4.22,0,0,1,64,47,4.59,4.59,0,0,0,66,49.61a12.5,12.5,0,0,0,11.33.75c1.71-.85,2.56-2.07,2.54-3.33h0Z"
                />
                <path
                    className="cls-13"
                    d="M47.31,70.05l-1.15-16.2-5.78.41,1.15,16.2a1.39,1.39,0,0,0,.94,1.25,4.52,4.52,0,0,0,4.11-.29A1.37,1.37,0,0,0,47.31,70.05Z"
                />
                <path
                    className="cls-14"
                    d="M45,53.93l1.16,16.21a1.37,1.37,0,0,1-.73,1.36,3.9,3.9,0,0,1-1.45.57,4.41,4.41,0,0,0,2.6-.65,1.37,1.37,0,0,0,.73-1.37l-1.15-16.2Z"
                />
                <path
                    className="cls-15"
                    d="M56.51,53.11l0-.13c-.11-.57-16.34-43.2-16.34-43.2s-10,44.49-10.06,45.11L30,55h0c0,2.08,1.44,4.08,4.29,5.47,5.4,2.62,13.78,2,18.72-1.33,2.61-1.78,3.72-4,3.41-6Z"
                />
                <path
                    className="cls-14"
                    d="M56.46,53c-.11-.57-16.34-43.2-16.34-43.2S53.21,49,53.31,49.61l0,.13h0c.31,2-.8,4.24-3.4,6-4.94,3.37-13.32,4-18.72,1.34-.3-.14-.57-.3-.83-.45a7.56,7.56,0,0,0,4,3.82c5.4,2.62,13.78,2,18.72-1.33,2.61-1.78,3.72-4,3.41-6h0Z"
                />
            </svg>
        </>
    );
}
